const Shadows = {
  headerRow: "0 4px 6px rgba(50,50,93,.11), 0 1px 3px rgba(0,0,0,.08)",
  pinnedColumn: "rgb(202 208 220) 5px 0px 10px -5px",
  switchKnob: "0px 1px 3px rgba(0, 0, 0, 0.1), 0px 1px 2px rgba(0, 0, 0, 0.06)",
  tooltip: "0px 10px 15px -3px rgba(0, 0, 0, 0.1)",
  default: "0 2px 4px 0 rgba(0, 0, 0, 0.24)"
};
export {
  Shadows
};
